enum SfpSignatureStatus {
  UNKNOWN = 0,
  DRAFTING = 1,
  TO_SIGN = 2,
  SIGNED = 3,
  DECLINED = 4,
  UNAVAILABLE = 5,
}

enum YousignVersion {
  LEGACY_IFRAME = 2,
  EMBEDDED_SDK = 3,
}

export {
  SfpSignatureStatus,
  YousignVersion
}
